// React
import { useEffect, useState } from "react";

// QR Code Components
import { useDevices } from "@yudiel/react-qr-scanner";
import {
  QRCodeFail,
  QRCodeReader,
  QRCodeScanner,
  QRCodeSummary,
} from "./Dialogs";
import { QR_STATES } from "Constants/QRConstants";

// MUI
import { Dialog } from "@mui/material";

// Context
import QRContext from "./QRContext";

// Styles
import styles from "./styles";

const QRCodeOpenContent = () => {
  const devices = useDevices();
  if (devices?.length > 0) {
    return <QRCodeScanner />;
  }
  return <QRCodeReader />;
};

/**
 * @brief Main QR Code rendering component that manages the state and flow of the QR code scanning process.
 * It conditionally renders the appropriate dialog content based on the current state of the QR code scanning process.
 */
const RenderQRCode = ({ onSuccess, onDialogClose, altCloseLabel }) => {
  const [qrState, setQRState] = useState(QR_STATES.OPEN);
  const [qrJSON, setQRJSON] = useState({});

  const handleDialogClose = () => {
    if (qrState === QR_STATES.SUCCESS && onSuccess) {
      onSuccess(qrJSON);
    }
    setQRState(QR_STATES.IDLE);
    setQRJSON({});
  };

  useEffect(() => {
    if (qrState === QR_STATES.IDLE && typeof onDialogClose === "function") {
      onDialogClose();
    }
  }, [onDialogClose, qrState]);

  const renderQR = () => {
    if (qrState === QR_STATES.OPEN) {
      return <QRCodeOpenContent />;
    } else if (qrState === QR_STATES.SUCCESS) {
      return (
        <QRCodeSummary
          closeFunction={handleDialogClose}
          altCloseLabel={altCloseLabel}
        />
      );
    } else if (qrState === QR_STATES.FAIL) {
      return <QRCodeFail />;
    }
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={qrState !== QR_STATES.IDLE}
      slotProps={styles.dialogPaperProps}
    >
      <QRContext.Provider value={{ qrState, setQRState, qrJSON, setQRJSON }}>
        {renderQR()}
      </QRContext.Provider>
    </Dialog>
  );
};

export default RenderQRCode;
